type Props = {
	children: React.ReactNode;
};

export const SearchByDetailLayout = ({ children }: Props) => (
	<div className="grid grid-cols-1 gap-2 p-4 text-sm tablet:grid-cols-2">{children}</div>
);
